import React from 'react';
import styles from './About.module.css';
import placeholder from '../assets/logo.png';

const About = () => {
  return (
    <section className={styles.about}>
      <div className={styles.content}>
        <img src={placeholder} alt="BETA Edge software engineering and consulting team" />
        <div>
          {/* <h2>About Us</h2> */}
          <h2>Software Meets Endless Possibilities</h2>
          <p>
            At B.E.T.A, we offer technology consulting, business solutions, digital transformation
            strategies to businesses worldwide. With expertise in digital transformation, 
            automation and business process optimization, we help companies in the United States, South East Asia, 
            Asia Pacific and Europe unlock their full potential. Our solutions enhance efficiency, scalability and 
            global market expansion through advanced data analysis, custom software solutions and digital innovation.
          </p>

          <p>
          We're here to help you bring your ideas to life. Whether you have a question, need support, or are ready to 
          start your next big project, we are eager to assist. Reach out now and experience our commitment to excellence and innovation. 
          Don't hesitate, let's create something amazing together.
          </p>
          {/* <p>
            At BETA, we harness cutting-edge technologies to craft engineering solutions that power industries and transform lives.
          </p> */}
        </div>
      </div>
    </section>
  );
};

export default About;
